module.exports = __webpack_public_path__ + "img/serve2.03f20acf.png";